// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__Qfmq7","boxTitle":"Qualiphy_boxTitle__1p7PI","box":"Qualiphy_box__fDyMZ","toggleWrap":"Qualiphy_toggleWrap__3E2C7"};